import { component$, type JSX } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';

const cssClasses = cva('', {
  variants: {
    direction: {
      left: 'rotate-180',
      right: '',
    },
  },
});

export default component$(
  ({ direction = 'left' }: { direction: 'left' | 'right' }): JSX.Element => {
    return (
      <svg
        class={cssClasses({ direction })}
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='#0A1529'
        xmlns='http://www.w3.org/2000/svg'
      >
        <title>{`Navigate ${direction}`}</title>
        <mask
          id='mask0_5735_282275'
          style={{ maskType: 'alpha' } as any}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='16'
          height='16'
        >
          <rect width='16' height='16' fill='#0A1529' />
        </mask>
        <g mask='url(#mask0_5735_282275)'>
          <path d='M4.7535 16L3.3335 14.58L9.9135 8L3.3335 1.42L4.7535 0L12.7535 8L4.7535 16Z' />
        </g>
      </svg>
    );
  }
);
